/**
 * @module
 * @internal
 */
export const firmwareFeatureReportId = 0xA3
